import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import toastr from '../toastr';
import Api from '../../services/ApiService';
import PrintJob from './PrintJob';
import FileService from '../../services/FileService';
import Socket from '../../services/SocketService';

const join = () => Socket.db.emit('join', 'PrintJob');

class PrintJobContainer extends Component {

  constructor(props) {
    super(props);
    this.state = {
      id: props.match.params.id,
      printJob: {},
      ready: false,
      layer: 'base',
    };

    this.handleResubmitJob = this.handleResubmitJob.bind(this);
    this.handleRetryJob = this.handleRetryJob.bind(this);
    this.handleGetInfo = this.handleGetInfo.bind(this);
    this.handleDownloadPdf = this.handleDownloadPdf.bind(this);
    this.handleLayerChange = this.handleLayerChange.bind(this);
  }

  componentDidMount() {
    this.getData();
    this.subscribe();
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  getData() {
    const { id } = this.state;

    return Api.get(`db/UPD1/${id}`).then(({ data }) => {
      this.setState({ printJob: data, ready: true, layer: data.layer });
      if (!data.pdfExists && data.overallStatus >= 1000) {
        // if the PDF does not exist and the job is done... otherwise, wait till the job completes
        Api.post(`print/job/${id}/pdf`).then(() => {
          this.setState({ printJob: { ...data, pdfExists: true } });
        });
      }
    });
  }

  subscribe() {
    join();
    Socket.db.on('connect', join);

    Socket.db.on('PrintJob.update', ({ data, id }) => {
      if (id === this.state.id) {
        const { printJob } = this.state;
        _.each(data, (value, key) => {
          if (!_.isObject(value)) {
            printJob[key] = value;
          }
          if (key === 'overallStatus' && value > 1000) {
            // assume the PDF exists
            printJob.pdfExists = true;
          }
        });
        this.setState({ printJob });
      }
    });
  }

  unsubscribe() {
    Socket.db.off('connect', join);
    Socket.db.off('PrintJob.update');
    Socket.db.emit('leave', 'PrintJob');
  }

  handleLayerChange(layer) {
    this.setState({ layer });
  }

  handleDownloadPdf() {
    const { id, layer } = this.state;
    window.open(FileService.downloadPath(`${id}-${layer}.pdf`));
  }

  handleRetryJob() {
    const { id } = this.state;
    toastr.success(`Retrying job ${id}`);
    Api.post('print/jobs/retry', { ids: [id] });
  }

  handleResubmitJob() {
    const { id } = this.state;
    toastr.success(`Resubmitting job ${id}`);
    Api.post('print/jobs/resubmit', { ids: [id] });
  }

  handleGetInfo(output) {
    return Api.get(`print/job/${this.state.id}/${output}`);
  }

  render() {
    const { id, printJob, ready, layer } = this.state;
    const { user } = this.props;

    if (!ready) {
      return null;
    }

    return (
      <PrintJob
        id={id}
        enableAdminControls={user.username === 'dsisupport'}
        layer={layer}
        printJob={printJob}
        handleLayerChange={this.handleLayerChange}
        handleDownloadPdf={this.handleDownloadPdf}
        handleResubmitJob={this.handleResubmitJob}
        handleRetryJob={this.handleRetryJob}
        handleGetInfo={this.handleGetInfo}
      />
    );
  }
}

PrintJobContainer.propTypes = {
  match: PropTypes.object,
  user: PropTypes.object,
};

const mapStateToProps = (state) => {
  return {
    user: state.app.user,
  };
};


export default connect(mapStateToProps)(PrintJobContainer);
